@if (flooriLoaderType.circle === type) {
<div class="floori-loader-ring-group modern-circle">
    <svg class="floori-loader-ring-outer" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient id="flooriLoaderGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stop-color="currentColor" stop-opacity="1" />
                <stop offset="60%" stop-color="currentColor" stop-opacity="0.4" />
                <stop offset="100%" stop-color="currentColor" stop-opacity="0" />
            </linearGradient>
        </defs>
        <circle class="loader-bg-track" cx="50" cy="50" r="38" fill="none" stroke="currentColor" stroke-width="5" opacity="0.12"></circle>
        <circle class="loader-active-track" cx="50" cy="50" r="38" fill="none" stroke="url(#flooriLoaderGrad)" stroke-width="5" stroke-linecap="round">
            <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="1s" repeatCount="indefinite" />
        </circle>
        <circle cx="50" cy="50" r="8" fill="currentColor" opacity="0.4">
            <animate attributeName="r" values="5;9;5" dur="1.8s" repeatCount="indefinite" />
            <animate attributeName="opacity" values="0.3;0.7;0.3" dur="1.8s" repeatCount="indefinite" />
        </circle>
    </svg>
</div>
} @else if (type === flooriLoaderType.floori) {
<div class="floori-loader-floori modern-floori">
    <div class="tile tile-1"></div>
    <div class="tile tile-2"></div>
    <div class="tile tile-3"></div>
    <div class="tile tile-4"></div>
</div>
} @else if (type === flooriLoaderType.stars) {
<div class="floori-loader-stars modern-stars">
    <floori-icon name="fl_star_s"></floori-icon>
    <floori-icon name="fl_star_s"></floori-icon>
    <floori-icon name="fl_star_s"></floori-icon>
</div>
} @if (showProgress) {
<div class="floori-loader-progress-bar">
    <floori-progress-loader
        class="loader-progress"
        [mainLabel]="progressValue"></floori-progress-loader>
</div>
} @if (label) {
<p class="floori-caption floori-semi-bold">
    {{ label }}
</p>
}
